import { useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";
import { useEditProductMutation } from "../../../features/api/productApi";
import { toast } from "react-toastify";

const UpdateProduct = ({ product }) => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => {
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setIsOpen(false);
    document.body.style.overflow = "auto";
  };

  const [product_name, setProduct] = useState("");

  useEffect(() => {
    if (product) {
      setProduct(product?.product_name);
    }
  }, [product]);

  const [updateProduct] = useEditProductMutation();
  const handleUpdate = async (id) => {
    try {
      const data = {
        id,
        product_name: product_name,
      };
      const response = await updateProduct(data);
      if (response?.error) {
        toast.error("Error...!!!");
      } else {
        setIsOpen(false);
        document.body.style.overflow = "auto";
        toast.success("Update Successful...");
      }
    } catch (error) {
      console.error("Error updating data:", error);
    }
  };
  return (
    <div>
      <span onClick={openModal}>
        <FaEdit className="text-xl text-blue-500 font-bold cursor-pointer" />
      </span>

      {isOpen && (
        <div className="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50 ">
          <div className="bg-slate-200 p-6 rounded shadow-md lg:w-[40%]">
            <button
              className="text-red-500 font-bold float-right"
              onClick={closeModal}
            >
              X
            </button>
            <div className="card bg-base-100 overflow-auto mt-4">
              <div className="card-body">
                <div
                  className="flex flex-col items-start font-extralight p-4"
                  style={{ lineHeight: "30px" }}
                >
                  <div className="flex flex-col justify-between w-full">
                    <label className="w-[40%]">Product:</label>
                    <input
                      type="text"
                      value={product_name}
                      onChange={(e) => setProduct(e.target.value)}
                      className="border border-gray-400 pl-1 w-full"
                    />
                  </div>
                  <button
                    onClick={() => handleUpdate(product?.id)}
                    className="bg-green-500 text-white font-bold mt-4 px-2 rounded block m-auto"
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UpdateProduct;
